import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { ProblemIntro } from "./components/sections/ProblemIntro";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Tools } from "./components/sections/Tools";
import { Bonuses } from "./components/sections/Bonuses";
import { Testimonials } from "./components/sections/Testimonials";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Outcomes } from "./components/sections/Outcomes";
import { AuthorMessage } from "./components/sections/AuthorMessage";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="3ml14tc2x3ukl">
      <MetaPixel data-id="element-1" data-mp="3rcj6618urx63" />
      <Hero data-id="element-2" data-mp="3rbzn2h7gv2qh" />
      <main data-id="element-3" data-mp="3rdaselgk8ijp">
        <ProblemIntro data-id="element-4" data-mp="3rcsxpt9jqcdw" />
        <BeforeAfter data-id="element-5" data-mp="3recdlirailf5" />
        <PainPoints data-id="element-6" data-mp="5ygolyg4xb6" />
        <Volumes data-id="element-7" data-mp="67yhm9c7y5s" />
        <Tools data-id="element-8" data-mp="4n53zyrel9i" />
        <Bonuses data-id="element-9" data-mp="56nfhsbnbo2" />
        <Testimonials data-id="element-10" data-mp="7su7f7e1n58" />
        <Offer data-id="element-11" data-mp="2zld2jatxbhc2" />
        <Guarantee data-id="element-12" data-mp="2zlv6yuqqp1v2" />
        <Outcomes data-id="element-13" data-mp="2zmenq84nlk7i" />
        <AuthorMessage data-id="element-14" data-mp="2zmwhmy3ufmc9" />
        <Faq data-id="element-15" data-mp="33mov9p83gioh" />
        <FinalCta data-id="element-16" data-mp="33mf623uvifju" />
      </main>
      <Footer data-id="element-17" data-mp="33ngf62sbwryx" />
      <FloatingCta data-id="element-18" data-mp="33n6wl09m5n39" />
      <PurchasePopup data-id="element-19" data-mp="33oi337ug18y2" />
    </div>;
}